// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2O8Us","left":"InfoRow_left__29C2z"};